import React, { useEffect, useState } from 'react';
import { Button, Input } from '../shared/ui';
import styles from './UserForm.module.css';

export default function UserForm({ open, onClose, onSubmit, initial, showActive = true, submitLabel = 'Save' }) {
  const [form, setForm] = useState({ name: '', email: '', role: 'User', active: true });

  useEffect(() => {
    if (initial) setForm(initial);
    else setForm({ name: '', email: '', role: 'User', active: true });
  }, [initial, open]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((f) => ({ ...f, [name]: type === 'checkbox' ? checked : value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(form);
  };

  return (
    <form onSubmit={handleSubmit} className={styles.form}>
      <Input
        label="Name"
        name="name"
        value={form.name}
        onChange={handleChange}
        required
        autoFocus
      />

      <Input
        label="Email"
        name="email"
        type="email"
        value={form.email}
        onChange={handleChange}
        required
      />

      <div className={styles.field}>
        <label className={styles.label} htmlFor="user-form-role">
          Role
        </label>
        <select
          id="user-form-role"
          name="role"
          value={form.role}
          onChange={handleChange}
          className={styles.select}
        >
          <option>User</option>
          <option>Admin</option>
        </select>
      </div>

      {showActive ? (
        <label className={styles.checkboxRow}>
          <input
            type="checkbox"
            name="active"
            checked={!!form.active}
            onChange={handleChange}
          />
          <span>Active</span>
        </label>
      ) : null}

      <div className={styles.actions}>
        <Button type="button" variant="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button type="submit" variant="primary">
          {submitLabel}
        </Button>
      </div>
    </form>
  );
}
